var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 87,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M120.2534 81.9416l-.007-28.028h-80.018v28.028c0 2.204-1.786 3.992-3.991 3.996h-.013c-2.21.004-4.004-1.787-4.004-3.996v-34.596c0-.782.636-1.417 1.417-1.417h93.205c.784 0 1.418.635 1.418 1.418l-.007 34.595c0 2.204-1.786 3.992-3.99 3.996h-.006c-2.21.004-4.004-1.786-4.004-3.996"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M120.2534 81.9416l-.007-28.028h-80.018v28.028c0 2.204-1.786 3.992-3.991 3.996h-.013c-2.209.004-4.004-1.787-4.004-3.996v-34.596c0-.782.636-1.417 1.417-1.417h93.205c.784 0 1.418.635 1.418 1.418l-.007 34.595c0 2.204-1.786 3.992-3.99 3.996h-.006c-2.21.004-4.004-1.785-4.004-3.996z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M57.3257 85.6203c-.421 0-.771-.351-.758-.771.407-12.753 10.875-22.967 23.727-22.967s23.319 10.214 23.726 22.967c.014.42-.335.771-.757.771h-45.938z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M57.3257 85.6203c-.421 0-.771-.351-.758-.771.407-12.753 10.874-22.967 23.727-22.967 12.851 0 23.318 10.214 23.725 22.967.015.42-.335.771-.756.771h-45.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M112.2603 33.8771c0-6.624-5.37-11.994-11.993-11.994-6.624 0-11.994 5.37-11.994 11.994s5.37 11.994 11.994 11.994c6.623 0 11.993-5.37 11.993-11.994"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M112.2603 33.8771c0-6.624-5.37-11.994-11.993-11.994-6.625 0-11.994 5.37-11.994 11.994s5.369 11.994 11.994 11.994c6.623 0 11.993-5.37 11.993-11.994z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.5454 73.7511c0-6.624-5.37-11.993-11.994-11.993S.5574 67.1271.5574 73.7511c0 6.624 5.37 11.994 11.994 11.994s11.994-5.37 11.994-11.994"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M24.5454 73.7511c0-6.624-5.37-11.993-11.994-11.993S.5574 67.1271.5574 73.7511c0 6.624 5.37 11.994 11.994 11.994s11.994-5.37 11.994-11.994z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M88.2817 33.8771c0-6.624-5.37-11.994-11.994-11.994s-11.993 5.37-11.993 11.994 5.369 11.994 11.993 11.994c6.624 0 11.994-5.37 11.994-11.994"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M88.2817 33.8771c0-6.624-5.37-11.994-11.994-11.994s-11.993 5.37-11.993 11.994 5.369 11.994 11.993 11.994c6.624 0 11.994-5.37 11.994-11.994z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M100.2671 12.8381c0-6.624-5.37-11.993-11.994-11.993s-11.993 5.369-11.993 11.993c0 6.624 5.369 11.994 11.993 11.994 6.624 0 11.994-5.37 11.994-11.994"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M100.2671 12.8381c0-6.624-5.37-11.993-11.994-11.993s-11.993 5.369-11.993 11.993c0 6.624 5.369 11.994 11.993 11.994 6.624 0 11.994-5.37 11.994-11.994z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.cc1a001816d1397cbad7c6c478e542d7.svg";
export { ForwardRef as ReactComponent };